import axios from 'axios';
import API_URL from './baseURL';

// Helper to handle token header
const authHeader = (token) => ({
  headers: { Authorization: `Bearer ${token}` }
});

// Always use absolute URLs (not /api/...) for reliability
export const getMaintenanceByVehicle = async (vehicleId, token) => {
  const res = await axios.get(`${API_URL}/maintenance/vehicle/${vehicleId}`, authHeader(token));
  return res.data;
};

export const getRecentMaintenance = async (token) => {
  const res = await fetch(`${API_URL}/maintenance/recent`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok) throw new Error('Failed to fetch recent maintenance logs');
  return res.json();
};

export const logMaintenance = async (form, token) => {
  const res = await axios.post(`${API_URL}/maintenance`, {
    vehicleId: form.vehicleId,
    description: form.description,
    date: form.date,
    cost: Number(form.cost),
    odometer: Number(form.odometer),
    workshop: form.workshopId,
    serviceType: form.serviceType
  }, authHeader(token));
  return res.data;
};

export const updateMaintenance = async (id, form, token) => {
  const res = await axios.put(`${API_URL}/maintenance/${id}`, {
    description: form.description,
    cost: Number(form.cost),
    odometer: Number(form.odometer),
    date: form.date,
    serviceType: form.serviceType
  }, authHeader(token));
  return res.data;
};

export const getWorkshopHistory = async (workshopId, token) => {
  try {
    console.log("📡 Calling GET /api/requests/workshop/" + workshopId);
    const res = await axios.get(`${API_URL}/requests/workshop/${workshopId}`, authHeader(token));
    return res.data;
  } catch (err) {
    console.error("❌ Failed to fetch workshop history", err);
    throw err;
  }
};

export const getMaintenanceAnalytics = async (token) => {
  const res = await axios.get(`${API_URL}/maintenance/analytics`, authHeader(token));
  return res.data;
};

// ---- UPDATED FUNCTION ----
export const logFromQuotation = async (form, token) => {
  const res = await axios.post(`${API_URL}/maintenance/from-quotation`, {
    vehicleId: form.vehicleId,
    workshopId: form.workshopId,
    quotationId: form.quotationId,
    removedParts: form.removedParts || [],
    technician: form.technician,
    notes: form.notes,
    odometerReading: form.odometerReading, // <-- already present
    date: form.date,                      // <-- already present
    serviceReason: form.serviceReason,     // <-- ADDED
    serviceType: form.serviceType          // <-- ADDED
  }, authHeader(token));
  return res.data;
};

/**
 * A vehicle's service history, for the workshop about to add to it.
 *
 * Scoped server-side to the owner, an assigned workshop, or an Admin — the
 * endpoint used to return any car's history to any logged-in account.
 */
export const fetchVehicleHistory = async (vehicleId, token) => {
  if (!vehicleId) return [];
  const res = await axios.get(`${API_URL}/maintenance/history/${vehicleId}`, authHeader(token));
  return Array.isArray(res.data) ? res.data : [];
};
